import React, {PropTypes} from "react";
import {AbstractReactComponent, field} from "mc/lib";

/**
 * Field pro enumy.
 */
class EnumField extends AbstractReactComponent {

    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.string).isRequired, // seznam enum hodnot
        itemRender: PropTypes.func, // funkce pro renderování popisků hodnotu
    };

    defaultRenderSuggestion = item => {
        return "[" + item + "]";
    };

    handleRenderSuggestion = (item) => {
        const {itemRender} = this.props;
        if (item) {
            return itemRender(item) || this.defaultRenderSuggestion(item);
        } else {
            return null;
        }
    };

    render() {
        const {itemRender, ...other} = this.props;

        return (
            <field.ObjectSuggest
                dropdown={true}
                removable={true}
                getItemValue={this.handleRenderSuggestion}
                renderSuggestion={this.handleRenderSuggestion}
                {...other}
            />
        );
    }
}

export default EnumField;
